/**
 * Pathname of the page that is actually on screen.
 *
 * During a navigation the router moves `location` to the target immediately,
 * but keeps rendering the old matches until every `beforeLoad` resolves. A
 * layout chosen from `location` therefore switches shell (auth page ->
 * public page with Header -> dashboard) around the old page, which remounts
 * it with fresh state. After an OTP login that reset the login form to the
 * empty email step for the whole /post-login -> /dashboard/therapist redirect
 * chain, so on a slow phone it looked like the code had not worked. The
 * deepest rendered match changes together with the Outlet, so the shell and
 * the page switch in the same render.
 */
export function renderedPathname(state: {
  matches: ReadonlyArray<{ pathname: string }>;
  location: { pathname: string };
}): string {
  return state.matches[state.matches.length - 1]?.pathname ?? state.location.pathname;
}
